import { atom } from 'recoil';

export const Vr360State = atom({
    key: 'Vr360State',
    default: null
});